const USER_ROLE = "role";
const ACCESS_TOKEN = "token";
const REFRESH_TOKEN = "refreshToken";
const EXPIRATION_DATE = "expirationDate";
const USER_DATA = "userData";
const PROFILE_COMPLETED = "profileCompleted";
const FCM_TOKEN = "FCM_TOKEN";

export const saveRole = role => {
  try {
    localStorage.setItem(USER_ROLE, role);
  } catch (err) {}
};

export const getRole = () => {
  try {
    return localStorage.getItem(USER_ROLE);
  } catch (err) {}
};

export const saveFCMToken = token => {
  try {
    localStorage.setItem(FCM_TOKEN, token);
  } catch (err) {}
};

export const getFCMToken = () => {
  try {
    let token = localStorage.getItem(FCM_TOKEN);
    return !token || token == null || token === "" ? null : token;
  } catch (err) {
    console.log(err);
  }
};

export const saveLoginInfo = (
  token,
  refreshToken,
  expirationDate,
  userData
) => {
  try {
    const serializedUserData = JSON.stringify(userData);

    localStorage.setItem(ACCESS_TOKEN, token);
    localStorage.setItem(REFRESH_TOKEN, refreshToken);
    localStorage.setItem(EXPIRATION_DATE, expirationDate);
    localStorage.setItem(USER_DATA, serializedUserData);
  } catch (err) {
    console.log(err);
  }
};

export const saveToken = (accessToken, refreshToken) => {
  try {
    const expirationDate = new Date(new Date().getTime() + 1800 * 1000);
    localStorage.setItem(ACCESS_TOKEN, accessToken);
    localStorage.setItem(REFRESH_TOKEN, refreshToken);
    localStorage.setItem(EXPIRATION_DATE, expirationDate);
  } catch (err) {}
};

export const getUserData = () => {
  try {
    const serializedUserData = localStorage.getItem(USER_DATA);

    if (serializedUserData === null) {
      return undefined;
    }

    return JSON.parse(serializedUserData);
  } catch (err) {
    console.log(err);
    return undefined;
  }
};

export const updateUserData = data => {
  try {
    const serializedUserData = getUserData();

    const userData = JSON.stringify({ ...serializedUserData, ...data });

    localStorage.setItem(USER_DATA, userData);
  } catch (err) {
    console.log(err);
  }
};

export const deleteLoginInfo = () => {
  try {
    localStorage.removeItem(ACCESS_TOKEN);
    localStorage.removeItem(REFRESH_TOKEN);
    localStorage.removeItem(EXPIRATION_DATE);
    localStorage.removeItem(USER_DATA);
    localStorage.removeItem(PROFILE_COMPLETED);
    localStorage.setItem("bankRedirect", false);
    localStorage.removeItem("viewMode");
    localStorage.removeItem("loginLoading");
    localStorage.removeItem("ongoingAppointment");
  } catch (err) {
    console.log(err);
  }
};

export const getToken = () => {
  try {
    let token = localStorage.getItem(ACCESS_TOKEN);
    return !token || token == null || token === "" ? "sdjnsc" : token;
  } catch (err) {
    console.log(err);
  }
};

export const getRefreshToken = () => {
  try {
    let refreshToken = localStorage.getItem(REFRESH_TOKEN);
    return !refreshToken || refreshToken == null || refreshToken === "" ? "sdjnsc" : refreshToken;
  } catch (err) {
    console.log(err);
  }
};

export const getExpirationDate = () => {
  try {
    return localStorage.getItem(EXPIRATION_DATE);
  } catch (err) {
    console.log(err);
  }
};
